module.exports = __webpack_public_path__ + "img/no-leave.0421db41.svg";